import { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import ProvisionalStatusGatewayImgSrc from '../../assets/images/provisional-state-gateway.svg';
import { UserTypeEnum } from '../api';
import { SessionContext } from '../app/contexts/SessionContext';
import { useDocumentTitle } from '../app/hooks/use-document-title';

export const ProvisionalStatusGateway = ({ userType }: { userType: UserTypeEnum }) => {
  useDocumentTitle('Welcome page');
  const { logout } = useContext(SessionContext);

  return (
    <Container className="justify-content-center align-items-center layout-bg-container" fluid>
      <Row className="mb-3 w-100">
        <Button className="ms-auto me-5" style={{ flex: 0 }} onClick={() => logout?.()}>
          Logout
        </Button>
      </Row>
      <Row className="d-flex min-h-80 justify-content-center align-items-center text-center">
        <Col style={{ background: 'white' }} xs={12} lg={{ span: 6, order: 2 }} className="p-5">
          <div className="my-5">
            {userType === UserTypeEnum.PROVIDER && (
              <>
                <h1 className="display-5 fw-bold text-primary text-center">
                  Thank you for your interest in Sendit Gigs!
                </h1>
                <br />
                <br />
                <h3 className="text-secondary text-center">
                  Our Provider Advocate will be reaching out to you shortly to welcome you and
                  extend a contract. <br />
                  <br /> Once you have a signed contract and completed background check, your
                  account will be activated.
                </h3>
                <br />
                <p className="fw-bold text-primary text-center">
                  If you have completed these two items and are having access issues, please reach
                  out to support@senditgigs.com
                </p>
              </>
            )}

            {userType === UserTypeEnum.HEALTHCARE_ENTITY_REP && (
              <>
                <h1 className="display-5 fw-bold text-primary text-center">
                  Thank you for your interest in using the Sendit Gigs Platform.
                </h1>
                <br />
                <br />
                <h3 className="text-secondary text-center">
                  We are verifying your credentials and account with Sendit Gigs. If your
                  organization has a contract with Sendit Gigs, we will be granting you access
                  shortly. <br />
                  <br />
                  If not, our leadership team will reach out and provide you with more information
                  about Sendit Gigs and how to initiate a contract. We look forward to partnering
                  with you.
                </h3>
                <br />
                <p className="fw-bold text-primary text-center">
                  Please email support@senditgigs.com if you have any questions.
                </p>
              </>
            )}

            {!userType && (
              <h1 className="display-5 fw-bold text-primary text-center">
                Thanks for submitting your info! <br />
                Your application is being reviewed.
              </h1>
            )}
          </div>
        </Col>
        <Col className="" xs={12} lg={{ span: 6, order: 1 }}>
          <img
            alt="Illustration of a man sat on a chair using a laptop"
            className="d-block my-5 mx-auto img-construction"
            loading="lazy"
            src={ProvisionalStatusGatewayImgSrc}
          />
        </Col>
      </Row>
    </Container>
  );
};
